import { Airport } from './Airport'
import Box from '@mui/material/Box'
import React from 'react'
import { Paper, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from 'usehooks-ts'

interface Props {
  airports: Airport[]
}

const AirportsCards = ({ airports }: Props) => {
  const { t } = useTranslation()
  const windowSize = useWindowSize().width
  const cardsMargin = 2
  const theme = useTheme()
  const cardsWidth = 200
  const marginSize = Number.parseInt(theme.spacing(1))
  const cardsPerLine = Math.floor(windowSize / (cardsWidth + marginSize * cardsMargin * 2))
  const remainingCardsOnLastLine = cardsPerLine >= airports.length ? 0 : airports.length % cardsPerLine
  const fillerWidth =
    remainingCardsOnLastLine === 0
      ? 0
      : (cardsPerLine - remainingCardsOnLastLine) * (cardsWidth + marginSize * cardsMargin * 2)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', marginY: 3, typography: 'h5' }}>{t('airports.selectAirportMessage')}</Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
        {airports.map((airport) => (
          <Paper
            key={airport.icao}
            elevation={3}
            sx={[
              { cursor: 'pointer', margin: cardsMargin, padding: 2, width: cardsWidth, textDecoration: 'none' },
              {
                '&:hover': {
                  boxShadow: 6,
                },
              },
            ]}
            component={Link}
            to={airport.icao}
          >
            <Box>{airport.icao}</Box>
            <Box>{airport.name}</Box>
          </Paper>
        ))}
        {fillerWidth !== 0 && <Box sx={{ width: fillerWidth }}></Box>}
      </Box>
    </Box>
  )
}

export default AirportsCards
